<template>
  <div id="Amap"></div>
</template>
<script>
import AmapLoader from '@amap/amap-jsapi-loader'
let map
export default {
  data() {
    return {}
  },
  created() {
    this.Amap()
  },
  methods: {
    Amap() {
      AmapLoader.load({
        key: '757a5643efee350208b0596863d27849', // 申请好的Web端开发者Key，首次调用 load 时必填
        plugins: ['AMap.Marker'] // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      }).then((AMap) => {
        map = new AMap.Map('Amap', {
          zoom: 16,
          center: [114.357038, 30.525144]
        })
        let marker = new AMap.Marker({
          position: new AMap.LngLat(114.357038, 30.525144) // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
        })
        map.add(marker)
        marker.setTitle('西索教育科技集团')
        marker.setLabel({
          direction: 'bottom',
          offset: new AMap.Pixel(10, 0), //设置文本标注偏移量
          content: "<div class='info'><p>西索教育科技集团</p>地址:武汉市洪山区群光中心3406</div>" //设置文本标注内容
        })
      })
    }
  }
}
</script>
<style lang="less" scoped>
#Amap {
  width: 100%;
  height: 530px;
  overflow: hidden;
}
/deep/.amap-icon img {
  width: 25px;
  height: 34px;
}
/deep/.amap-marker-label {
  border: 0;
  background-color: transparent;
  .info {
    box-shadow: 0 2px 6px 0 rgba(114, 124, 245, 0.5);
    padding: 9px 15px;
    background: #ffffff;
    border-radius: 5px;
    p {
      font-size: 14px;
      font-family: 'Bold';
      margin-bottom: 10px;
    }
  }
}
</style>
